<template>
  <div class="view box grow" style="overflow-y: auto">
    <page-headers
      :header="header"
      :breadcrumbs="breadcrumbs"
      :is-border="true"
      :documentation="documentation"
      class="box"
    />
    <el-tabs v-model="activeView" @tab-click="changeView">
      <el-tab-pane label="VMs" name="hosts"></el-tab-pane>
      <el-tab-pane label="Containers" name="containers"></el-tab-pane>
      <el-tab-pane label="Container Images" name="container-images"></el-tab-pane>
      <!-- <el-tab-pane label="Cloud Discovery" name="cloud-discovery"></el-tab-pane> -->
      <!-- <el-tab-pane label="Kubernetes Discovery" name="kubernetes-discovery"></el-tab-pane> -->
      <!-- <el-tab-pane label="Snyk Discovery" name="snyk-discovery"></el-tab-pane> -->
    </el-tabs>

    <router-view class="full-height" />
  </div>
</template>

<script>
import PageHeaders from '@/components/layout/PageHeaders.vue'

export default {
  name: 'AssetView',
  data () {
    return {
      header: 'VMs',
      breadcrumbs: [{ title: 'Assets' }, { title: 'VMs' }],
      activeView: 'hosts',
      documentation: 'page-hosts',
      routePath: '/assets/hosts'
    }
  },
  beforeMount () {
    // on load of this view, collapse the sidebar nav (this view is two levels deep from App.vue)
    if (!_.isUndefined(this.$parent.collapseNav)) {
      this.$set(this.$parent, 'collapseNav', true)
    }

    // If window refreshed, stay on previous rules page
    if (performance.navigation.type === 1) {
      this.$router.push({ name: this.$route.name, params: this.$route.params, query: this.$route.query })
    }
    // else {
    //   // set default path for attack progression rules
    //   this.$router.push({ name: 'hosts', params: this.$route.params, query: this.$route.query })
    // }
    this.activeView = this.$route.path.split('/').reverse()[0]

    if (this.activeView === 'containers') {
      this.header = 'Containers'
      this.breadcrumbs = [{ title: 'Assets' }, { title: 'Containers' }]
      this.routePath = '/assets/containers'
      this.documentation = 'page-containers'
    } else if (this.activeView === 'container-images') {
      this.header = 'Containers Images'
      this.breadcrumbs = [{ title: 'Assets' }, { title: 'Containers Images' }]
      this.routePath = '/assets/container-images'
      this.documentation = 'page-container-images'
    } else if (this.activeView === 'cloud-discovery') {
      this.header = 'Cloud Discovery'
      this.breadcrumbs = [{ title: 'Assets' }, { title: 'Cloud Discovery' }]
      this.routePath = '/assets/cloud-discovery'
    } else if (this.activeView === 'kubernetes-discovery') {
      this.header = 'Kubernetes Discovery'
      this.breadcrumbs = [{ title: 'Assets' }, { title: 'Kubernetes Discovery' }]
      this.routePath = '/assets/kubernetes-discovery'
    } else if (this.activeView === 'snyk-discovery') {
      this.header = 'Snyk Discovery'
      this.breadcrumbs = [{ title: 'Assets' }, { title: 'Snyk Discovery' }]
      this.routePath = '/assets/snyk-discovery'
    }
  },
  methods: {
    changeView (tab, event) {
      if (tab.name === 'cloud-discovery') {
        this.header = 'Cloud Discovery'
        this.breadcrumbs = [{ title: 'Assets' }, { title: 'Cloud Discovery' }]
        this.routePath = '/assets/cloud-discovery'
      } else if (tab.name === 'kubernetes-discovery') {
        this.header = 'Kubernetes Discovery'
        this.breadcrumbs = [{ title: 'Assets' }, { title: 'Kubernetes Discovery' }]
        this.routePath = '/assets/kubernetes-discovery'
      } else if (tab.name === 'snyk-discovery') {
        this.header = 'Snyk Discovery'
        this.breadcrumbs = [{ title: 'Assets' }, { title: 'Snyk Discovery' }]
        this.routePath = '/assets/snyk-discovery'
      } else if (tab.name === 'containers') {
        this.header = 'Containers'
        this.breadcrumbs = [{ title: 'Assets' }, { title: 'Containers' }]
        this.routePath = '/assets/containers'
        this.documentation = 'page-containers'
      } else if (tab.name === 'container-images') {
        this.header = 'Containers Images'
        this.breadcrumbs = [{ title: 'Assets' }, { title: 'Containers Images' }]
        this.routePath = '/assets/container-images'
        this.documentation = 'page-container-images'
      } else {
        this.header = 'VMs'
        this.breadcrumbs = [{ title: 'Assets' }, { title: 'VMs' }]
        this.routePath = '/assets/hosts'
        this.documentation = 'page-hosts'
      }
      this.$router.push(this.routePath)
    },
    setActiveView (view) {
      this.activeView = view.name
      this.header = view.header
      this.breadcrumbs = view.breadcrumbs
      this.documentation = view.documentation
    }
  },
  components: {
    PageHeaders
  },
  watch: {
    '$route': {
      handler: function (newVal, oldVal) {
        if (newVal && newVal.name === 'hosts') {
          this.setActiveView({
            name: 'hosts',
            breadcrumbs: [{ title: 'Assets' }, { title: 'VMs' }],
            header: 'VMs',
            documentation: 'page-hosts'
          })
        }
      }
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.icon-text-button {
  background: var(--main-blue);
  padding: 5px 10px;

  span {
    .c-icon {
      color: white;
      font-size: 1.2em;
      vertical-align: text-bottom;
      margin-right: 5px;
    }
    span {
      color: white;
      margin-bottom: 6px;
    }
    a {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/hosts/AssetView.vue